// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/handshake.js';

import { paths } from '../generated/handshake';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('handshake', Original, paths);
